import React, { useCallback } from 'react';
import { FieldValue } from 'react-hook-form';
import DocumentTitle from '../../utilComponents/DocumentTitle';
import ResourceFormView from '../../apiForm/scaffold/ResourceFormView';
import useTransactionConfigApi from '../../project/useTransactionConfigApi';
import ClosingLogSinkForm from './ClosingLogSinkForm';

export default function ClosingLogSinkView() {
  const api = useTransactionConfigApi();

  const fetch = useCallback(async () => {
    const config = await api.getTransactionConfig(null);
    return config;
  }, [api]);

  const onSubmit = useCallback(
    async (data: FieldValue<any>) => {
      await api.updateTransactionConfig(data);
    },
    [api],
  );

  return (
    <>
      <DocumentTitle translationID="transactionConfig.closingLogSink.headline" />
      <div>
        <ResourceFormView
          actionName="closingLogSinks"
          Form={ClosingLogSinkForm}
          fetch={fetch}
          submit={onSubmit}
        />
      </div>
    </>
  );
}
